import { Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '..'


@Module({ namespaced: true })
export default class SubscribeNewsletterModule extends VuexModule {
  isOpen = false

  @Mutation
  open(): void {
    this.isOpen = true
    // use the content overlay onclick function
    // because v-click-outside doesn't work together with the request sample button @click
    store.commit('openContentOverlay', () => store.commit('subscribeNewsletter/close'))
  }

  @Mutation
  close(): void {
    this.isOpen = false
    store.commit('closeContentOverlay', false)
  }
}
